import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class MemoryStorageService {
    private static data: { [key: string]: string } = {};
    // Use localStorage in development, in-memory storage in production
    static setItem(key: string, value: string): void {
        //if (!environment.production) {
        localStorage.setItem(key, value);
        // } else {
        //   sessionStorage.setItem(key, value)
        //   //this.data[key] = value;
        // }
    }
    static getItem(key: string): string {
        //if (!environment.production) {
        const value = localStorage.getItem(key);
        return value ? value : null;
        // } else {
        //   const value = sessionStorage.getItem(key);
        //   return value ? value : null;
        //   //return this.data[key] !== undefined ? this.data[key] : null;
        // }
    }
    static removeItem(key: string): void {
        //if (!environment.production) {
        localStorage.removeItem(key);
        // } else {
        //   sessionStorage.removeItem(key);
        //   //delete this.data[key];
        // }
    }
    static clear(): void {
        //if (!environment.production) {
        localStorage.clear();
        // } else {
        //   //this.data = {};
        //   sessionStorage.clear();
        // }
    }
}